export default __webpack_public_path__ + "static/media/suggestion-chips-dialog1.29d8a9f3.png";